import { Config } from 'config/envConfig';
import React, { useState } from 'react';
import axios from 'axios';
import {
    faCheckCircle,
    faCircleXmark,
} from '@fortawesome/free-solid-svg-icons';
import {
    alert,
    AlertType,
    Button,
    Input,
    LoadingView,
    TextArea,
} from '@quyva/shared-ui';
import { getUrl } from '../pdfDisplay/utils';
import { isValidNamingRegex } from '@quyva/common';


const AddAgentView = ({ setAddMode, agentList, user, getAgentList }) => {
    const [agentName, setAgentName] = useState('');
    const [creationString, setCreationString] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleAgentNameChange = (e) => {
        const value = e.target.value;
        if (!isValidNamingRegex(value)) {
            return;
        }
        setAgentName(value);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!agentName) {
            alert(AlertType.WARNING, 'Agent name cannot be empty.');
            return;
        }

        const nameExists = agentList.some(
            (agent) => agent.name.toLowerCase() === agentName.toLowerCase()
        );

        if (nameExists) {
            alert(AlertType.WARNING, 'Agent name already exists.');
            return;
        }

        // --- THIS IS THE REAL API LOGIC BRANCH ---
        try {
            setIsLoading(true);

            const dynamicUrl = getUrl(
                `http://${Config.FAST_API_HOST}:${Config.FAST_API_PORT}/agent_manager/create_agent`
            );
            const formData = new FormData();
            formData.append('name', agentName);
            formData.append('creationString', creationString);
            formData.append('user_email', user.email);

            const encodedToken = encodeURIComponent(user.token);
            await axios.post(dynamicUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: encodedToken,
                },
            });

            alert(AlertType.SUCCESS, `${agentName} created successfully!`);
            await getAgentList(); // Re-fetch data in the main view
            setAddMode(false); // Close the modal
        } catch (err) {
            const errorMessage =
                err.response?.data?.detail || `Error creating ${agentName}.`;
            alert(AlertType.ERROR, errorMessage, false);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className='w-[60vw] min-w-[500px] flex-col px-6 py-6 rounded-xl bg-backgrounds-slate text-texts-secondary300'>
            {isLoading ? (
                <div className='w-full h-48 flex justify-center items-center'>
                    <LoadingView
                        loadingText={'Creating Agent...'}
                        inLine={false}
                    />
                </div>
            ) : (
                <form>
                    <div className='mb-5'>
                        <label className='font-semibold mb-2 block'>
                            Agent Name
                        </label>
                        <Input
                            type='text'
                            placeholder='Enter agent name'
                            value={agentName}
                            maxLength={60}
                            onChange={handleAgentNameChange}
                            autoFocus
                        />
                    </div>
                    <div className='mb-5'>
                        <label className='font-semibold mb-2 block'>
                            Agent Creation String
                        </label>
                        <TextArea
                            placeholder='Enter agent creation string'
                            value={creationString}
                            onChange={(e) => setCreationString(e.target.value)}
                            rows={10}
                            className='p-2'
                            resize={'none'}
                        />
                    </div>
                    <div className='flex items-center justify-between w-full mt-4'>
                        <Button
                            type='danger'
                            icon={faCircleXmark}
                            className='w-1/3'
                            text={'Cancel'}
                            onClick={() => setAddMode(false)}
                        />
                        <Button
                            type='success'
                            icon={faCheckCircle}
                            className='w-1/3'
                            text={'Create'}
                            onClick={handleSubmit}
                            disabled={!agentName}
                        />
                    </div>
                </form>
            )}
        </div>
    );
};
export default AddAgentView;
